import { useAuth } from '@hourly/contexts/AuthContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Spinner from '@shared/components/Spinner';
import styles from './logout.module.css';

export default function Logout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const doLogout = async () => {
      try {
        await logout();
      } finally {
        navigate('/login');
      }
    };

    doLogout();
  }, [logout, navigate]);

  return (
    <div className={styles.spinnerWrap}>
      <Spinner />
    </div>
  );
}
